import React, { useEffect, useState } from 'react';

const withClientSideRenderOnly = () => WrappedComponent => {
    const WithClientSideRenderOnly = function (props) {
        const [isClient, setIsClient] = useState(false);

        useEffect(() => {
            setIsClient(true);
        }, []);

        if (!isClient) {
            return null;
        }

        return <WrappedComponent {...props} />;
    };

    const wrappedName = WrappedComponent.displayName || WrappedComponent.class;
    WithClientSideRenderOnly.prototype.class = `WithClientSideRenderOnly-${wrappedName}`;
    WithClientSideRenderOnly.class = `WithClientSideRenderOnly-${wrappedName}`;
    WithClientSideRenderOnly.displayName = `WithClientSideRenderOnly(${wrappedName})`;

    return WithClientSideRenderOnly;
};

export default withClientSideRenderOnly;
